import { render } from "./ComoParticiparView.vue?vue&type=template&id=ab84b11a&scoped=true"
const script = {}

import "./ComoParticiparView.vue?vue&type=style&index=0&id=ab84b11a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab84b11a"]])

export default __exports__